var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, cloneElement } from 'react';
import { Search, Visible, Hidden } from '../icon';
import { inputWrapperStyle, inputStyle } from './styles';
import IconLeft from './icon-left';
import EnhancerRight from './enhancer-right';
import Enhancer from './enhancer';
function InputInternal(_a, ref) {
    var type = _a.type, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.inverted, inverted = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.error, error = _e === void 0 ? false : _e, iconLeft = _a.iconLeft, enhancerRight = _a.enhancerRight, onFocus = _a.onFocus, onBlur = _a.onBlur, restProps = __rest(_a, ["type", "size", "inverted", "disabled", "error", "iconLeft", "enhancerRight", "onFocus", "onBlur"]);
    var _f = __read(useState(false), 2), isFocused = _f[0], setIsFocused = _f[1];
    var _g = __read(useState(false), 2), isPasswordVisible = _g[0], setIsPasswordVisible = _g[1];
    function handleFocus(event) {
        if (onFocus) {
            onFocus(event);
        }
        setIsFocused(true);
    }
    function handleBlur(event) {
        if (onBlur) {
            onBlur(event);
        }
        setIsFocused(false);
    }
    function renderIcon(originalIcon, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props) {
        // Check if the Icon has a provided custom size prop already
        return originalIcon.props.size
            ? cloneElement(originalIcon, __assign({}, props))
            : cloneElement(originalIcon, __assign({ 
                // Handle large buttons having medium sized Icons by default, and small / medium as defined
                size: size === 'large' ? 'medium' : size }, props));
    }
    function renderIconLeft() {
        if (type === 'search') {
            return (_jsx(IconLeft, __assign({}, { size: size, inverted: inverted }, { children: _jsx(Search, { "data-testid": "search-icon", size: size === 'large' ? 'medium' : size }) })));
        }
        else if (iconLeft) {
            return (_jsx(IconLeft, __assign({}, { size: size, inverted: inverted }, { children: renderIcon(iconLeft) })));
        }
        return null;
    }
    function renderEnhancerRight() {
        if (type === 'password') {
            return (_jsx(EnhancerRight, __assign({}, { size: size, inverted: inverted }, { children: _jsx(Enhancer, __assign({ "aria-label": "".concat(isPasswordVisible ? 'Hide' : 'Show', " password text"), onClick: function () { return setIsPasswordVisible(!isPasswordVisible); }, disabled: disabled, size: size }, { children: isPasswordVisible ? _jsx(Hidden, {}) : _jsx(Visible, {}) })) })));
        }
        else if (enhancerRight) {
            // Disable custom enhancer when whole input is disabled by passing disabled prop
            return (_jsx(EnhancerRight, __assign({}, { size: size, inverted: inverted }, { children: renderIcon(enhancerRight, {
                    disabled: disabled,
                }) })));
        }
        return null;
    }
    return (_jsxs("div", __assign({ css: inputWrapperStyle({ size: size, disabled: disabled, isFocused: isFocused }) }, { children: [renderIconLeft(), _jsx("input", __assign({}, restProps, (type === 'password' && {
                autoComplete: 'new-password',
                spellCheck: false,
            }), { ref: ref, type: isPasswordVisible ? 'text' : type, disabled: disabled, "aria-invalid": error, onFocus: handleFocus, onBlur: handleBlur, css: inputStyle({
                    hasError: error,
                    size: size,
                    inverted: inverted,
                    hasIconLeft: type === 'search' || !!iconLeft,
                    hasEnhancerRight: type === 'password' || !!enhancerRight,
                }) })), renderEnhancerRight()] })));
}
export default InputInternal;
